import logo from "./logo.svg";
import "./App.css";
import Navbar from "./Components/Navbar";
import Home from "./Components/Home";
import Footer from "./Components/Footer";
import { Routes, Route } from "react-router-dom";
import Dashboard from "./Components/Admin/Dashboard";
import Sidebar from "./Components/Admin/Sidebar";
import AddGallery from "./Components/Admin/Gallery/AddGallery";
import Gallery from "./Components/Admin/Gallery/Gallery";
import WebGallery from "./Components/Gallery";
import About from "./Components/About";
import Publications from "./Components/Publications";
import AdminPublications from "./Components/Admin/Publication/AdminPublications";
import AddPublication from "./Components/Admin/Publication/AddPublication";
import Login from "./Components/Login";
import GenSecratary from "./Components/Admin/Committee/GenSecratary";
import Presidents from "./Components/Admin/Committee/Presidents";
import AddGenSecretary from "./Components/Admin/Committee/AddGenSecretary";
import AddPresident from "./Components/Admin/Committee/AddPresident";
import Committee from "./Components/Committee";
import Contact from "./Components/Contact";
import ProtectedRoute from "./Components/Admin/ProtectedRoute";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Navbar />
              <main class="main">
                <Home />
              </main>
              <Footer />
            </>
          }
        />

        <Route
          path="/about-us"
          element={
            <>
              <Navbar />
              <main class="main">
                <About />
              </main>
              <Footer />
            </>
          }
        />

        <Route
          path="/gallery"
          element={
            <>
              <Navbar />
              <main class="main">
                <WebGallery />
              </main>
              <Footer />
            </>
          }
        />

        <Route
          path="/publications"
          element={
            <>
              <Navbar />
              <main class="main">
                <Publications />
              </main>
              <Footer />
            </>
          }
        />

        <Route
          path="/committee"
          element={
            <>
              <Navbar />
              <main class="main">
                <Committee />
              </main>
              <Footer />
            </>
          }
        />

        <Route
          path="/contact-us"
          element={
            <>
              <Navbar />
              <main class="main">
                <Contact />
              </main>
              <Footer />
            </>
          }
        />

        <Route
          path="/login"
          element={
            <>
              <Navbar />
              <main class="main">
                <Login />
              </main>
              <Footer />
            </>
          }
        />

        <Route
          path="/dashboard"
          element={
            <>
              <ProtectedRoute>
                <div className="adminpanel">
                  <Sidebar />
                  <Dashboard />
                </div>
              </ProtectedRoute>
            </>
          }
        />

        <Route
          path="/admin-gallery"
          element={
            <>
              <ProtectedRoute>
                <div className="adminpanel">
                  <Sidebar />
                  <Gallery />
                </div>
              </ProtectedRoute>
            </>
          }
        />

        <Route
          path="/admin-add-gallery"
          element={
            <>
              <ProtectedRoute>
                <div className="adminpanel">
                  <Sidebar />
                  <AddGallery />
                </div>
              </ProtectedRoute>
            </>
          }
        />

        <Route
          path="/admin-publications"
          element={
            <>
              <ProtectedRoute>
                <div className="adminpanel">
                  <Sidebar />
                  <AdminPublications />
                </div>
              </ProtectedRoute>
            </>
          }
        />

        <Route
          path="/admin-add-publication"
          element={
            <>
              <ProtectedRoute>
                <div className="adminpanel">
                  <Sidebar />
                  <AddPublication />
                </div>
              </ProtectedRoute>
            </>
          }
        />

        <Route
          path="/admin-gen-secretary"
          element={
            <>
              <ProtectedRoute>
                <div className="adminpanel">
                  <Sidebar />
                  <GenSecratary />
                </div>
              </ProtectedRoute>
            </>
          }
        />

        <Route
          path="/admin-add-gen-secretary"
          element={
            <>
              <ProtectedRoute>
                <div className="adminpanel">
                  <Sidebar />
                  <AddGenSecretary />
                </div>
              </ProtectedRoute>
            </>
          }
        />

        <Route
          path="/admin-presidents"
          element={
            <>
              <ProtectedRoute>
                <div className="adminpanel">
                  <Sidebar />
                  <Presidents />
                </div>
              </ProtectedRoute>
            </>
          }
        />

        <Route
          path="/admin-add-president"
          element={
            <>
              <ProtectedRoute>
                <div className="adminpanel">
                  <Sidebar />
                  <AddPresident />
                </div>
              </ProtectedRoute>
            </>
          }
        />
      </Routes>
    </div>
  );
}

export default App;
